import { Device } from '@/../client-generator/generated-clients/plants';
import ProtocolConstants from './protocol-constants';

/**
 * Defines the device groups which are used in rules
 * In the future this may come from an API
 */
class SlotsConfigService {
  static deviceConstants = {
    '8BtnDeviceOrCrystalDeviceWithPairSelection': [
      ProtocolConstants.Device1_3_49,
      ProtocolConstants.Device1_1_49,
      ProtocolConstants.Device2_4_49,
      ProtocolConstants.Device2_2_17,
      ProtocolConstants.Device2_4_17,
      ProtocolConstants.Device1_3_27,
      ProtocolConstants.Device2_2_27,
      ProtocolConstants.Device1_3_28,
    ],
    automationCommandsSpecialDevices: [ProtocolConstants.Device1_5_119],
    isDevice15117orDevice15121orDevice15119: [
      ProtocolConstants.Device1_5_117,
      ProtocolConstants.Device1_5_121,
      ProtocolConstants.Device1_5_119,
      ProtocolConstants.Device0_0_121,
    ],
    isDevice3477: [
      ProtocolConstants.Device1_0_152,
      ProtocolConstants.Device2_2_152,
    ],
    isDeviceF428: [
      ProtocolConstants.Device1_0_149,
      ProtocolConstants.Device2_0_149,
    ],
    isDeviceCrystal8Scene: [
      ProtocolConstants.Device2_2_17,
      ProtocolConstants.Device2_4_17,
      ProtocolConstants.Device1_3_27,
      ProtocolConstants.Device2_2_27,
      ProtocolConstants.Device1_3_28,
      ProtocolConstants.Device1_3_49,
      ProtocolConstants.Device1_1_49,
      ProtocolConstants.Device2_4_49,
    ],
  };

  static is8BtnDeviceOrCrystalDeviceWithPairSelection = function (
    device?: Device
  ) {
    return (
      device &&
      device.modelObject &&
      SlotsConfigService.deviceConstants[
        '8BtnDeviceOrCrystalDeviceWithPairSelection'
      ].includes(device.modelObject)
    );
  };

  static automationCommandsSpecialDevices = function (device?: Device) {
    return (
      device &&
      device.modelObject &&
      SlotsConfigService.deviceConstants[
        'automationCommandsSpecialDevices'
      ].includes(device.modelObject)
    );
  };

  static isDevice15117orDevice15121orDevice15119 = function (device?: Device) {
    return (
      device &&
      device.modelObject &&
      SlotsConfigService.deviceConstants[
        'isDevice15117orDevice15121orDevice15119'
      ].includes(device.modelObject)
    );
  };

  static isDevice3477 = function (device?: Device) {
    return (
      device &&
      device.modelObject &&
      SlotsConfigService.deviceConstants['isDevice3477'].includes(
        device.modelObject
      )
    );
  };

  static isDeviceF428 = function (device?: Device) {
    return (
      device &&
      device.modelObject &&
      SlotsConfigService.deviceConstants['isDeviceF428'].includes(
        device.modelObject
      )
    );
  };

  static isDeviceCrystal8Scene = function (device?: Device) {
    return (
      device &&
      device.modelObject &&
      SlotsConfigService.deviceConstants['isDeviceCrystal8Scene'].includes(
        device.modelObject
      )
    );
  };
}

export default SlotsConfigService;
